import getStore from '../store/store';
import type { OcpsStoreState } from '../store/schema/OcpsPolicyStore';

export default function getOcpsPolicyStoreState(): OcpsStoreState {
    return getStore().state;
}
